module.exports = __webpack_public_path__ + "img/buildings-buttons-add.c45dc0fd.svg";